import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageDecorated } from 'pages/page';
import { getUploadProgressSelector, getVideoIsPublishedSelector, getSkipSelectVideoSelector } from './selectors';
import { uploadResetAction } from './actions';
import { SelectVideoDecorated } from './select-video';
import { PublishVideoDecorated } from './publish-video';
import { UploadCompleted } from './upload-completed';
import { getNewRelicAgent } from 'newRelicAgent';

export * from 'pages/upload.page/publish-video/fragments';
export * from 'pages/upload.page/publish-video';
export * from 'pages/upload.page/select-video';
export * from 'pages/upload.page/upload-completed';
export * from 'pages/upload.page/saga';
export * from 'pages/upload.page/effects';
export * from 'pages/upload.page/selectors';
export * from 'pages/upload.page/reducer';
export * from 'pages/upload.page/actions';
export * from 'pages/upload.page/utils';

export class UploadPage extends React.Component {
  componentDidCatch(error) {
    getNewRelicAgent().noticeError(error);
  }

  render() {
    return <UploadComponent {...this.props} />;
  }
}

const UploadComponent = ({ match, isPodcast }) => {
  const dispatch = useDispatch();
  const sessionId = match?.params?.sessionId;

  useEffect(() => {
    return () => {
      dispatch(uploadResetAction());
    };
  }, [dispatch, sessionId]);

  const progress = useSelector(getUploadProgressSelector);
  const isPublished = useSelector(getVideoIsPublishedSelector);
  const skipSelectVideo = useSelector(getSkipSelectVideoSelector);

  let child;
  if (progress === 0 && !skipSelectVideo) {
    child = <SelectVideoDecorated isPodcast={isPodcast} />;
  } else if (progress > 0 && !isPublished) {
    child = <PublishVideoDecorated isPodcast={isPodcast} />;
  } else if (isPublished) {
    child = <UploadCompleted isPodcast={isPodcast} />;
  }

  return <PageDecorated className="ct-upload-page">{child}</PageDecorated>;
};
